import React, { useState } from 'react';
import AppRouter from "./Routers/AppRouter";
import { DynamicDataProvider } from "./Context/DynamicContext";
import usePWAInstallPrompt from './Context/usePWAInstallPrompt';
import PWAInstallPopup from './Components/PWAInstallPopup';
function App() {
  const { isReady, promptInstall } = usePWAInstallPrompt();
  const [showPopup, setShowPopup] = useState(true);

  const handleInstall = async () => {
   await promptInstall();
    setShowPopup(false);
  };

  return (
    <>
    <DynamicDataProvider>
      <AppRouter />
    </DynamicDataProvider>

    {isReady && showPopup && (
      <PWAInstallPopup
        onInstallClick={handleInstall}
        onClose={() => setShowPopup(false)}
      />
    )}
  </>
  );
}

export default App;
